import React from 'react';
import Loadable from 'react-loadable';

import Loader from '../components/Loader';

function Loading() {
    return <Loader />;
}

const Dashboard = Loadable({
    loader: () => import('../modules/applications/views/index'),
    loading: Loading,
});

const Analytics = Loadable({
    loader: () => import('../modules/analytics/views/index'),
    loading: Loading,
});

const userList = Loadable({
    loader: () => import('../modules/user/views/users'),
    loading: Loading,
});

const NewUser = Loadable({
    loader: () => import('../modules/user/views/NewUser'),
    loading: Loading,
});
const UserPermission = Loadable({
    loader: () => import('../modules/user/views/UserPermission'),
    loading: Loading,
});

const DoohSummaryReports = Loadable({
    loader: () => import('../modules/dooh-report/views/download'),
    loading: Loading,
});

const SspSummaryReports = Loadable({
    loader: () => import('../modules/ssp-report/views/index'),
    loading: Loading,
});

const DspSummaryReports = Loadable({
    loader: () => import('../modules/dsp-report/views/index'),
    loading: Loading,
});

const categoryList = Loadable({
    loader: () => import('../modules/category/views/index'),
    loading: Loading,
});

const NewCategory = Loadable({
    loader: () => import('../modules/category/views/NewCategory'),
    loading: Loading,
});

const NewCategoryGroup = Loadable({
    loader: () => import('../modules/category/views/NewCategoryGroup'),
    loading: Loading,
});

// const AdvertiserDetailSummary = Loadable({
//     loader: () => import('../modules/dsp-report/views/components/advertiser'),
//     loading: Loading,
// })


const routes = [
    { path: '/dashboard', name: 'Dashboard', component: Dashboard, exact: true, isAuth: true },
    { path: '/analytics', name: 'Analytics', component: Analytics, exact: true, isAuth: true, roles: ['ADMIN'] },
    { path: '/user', name: 'Users', component: userList, exact: true, isAuth: true },
    { path: '/user/new', name: 'New User', component: NewUser, exact: true, isAuth: true },
    { path: '/user/edit/:id', name: 'Edit User', component: NewUser },
    { path: '/user/permission', name: 'User Permission', component: UserPermission, exact: true, isAuth: true },
    { path: '/user/permission/edit/:id', name: 'Edit Permission', component: UserPermission },
    { path: '/summary/1', name: 'DOOH Reports', component: DoohSummaryReports, exact: true, isAuth: true },
    { path: '/summary/2', name: 'SSP Reports', component: SspSummaryReports, exact: true, isAuth: true },
    { path: '/summary/3', name: 'DSP Reports', component: DspSummaryReports, exact: true, isAuth: true },
    { path: '/summary/3/details/:campaignId', name: 'DSP Reports', component: DspSummaryReports, exact: true, isAuth: true },
    { path: '/category', name: 'Category', component: categoryList, exact: true, isAuth: true, roles: ['ADMIN'] },
    { path: '/category/new', name: 'New Category', component: NewCategory, exact: true, isAuth: true, roles: ['ADMIN'] },
    { path: '/category/edit/:id', name: 'Edit Category', component: NewCategory, roles: ['ADMIN'] },
    { path: '/category-group/new', name: 'New Category Group', component: NewCategoryGroup, exact: true, isAuth: true, roles: ['ADMIN'] },
    { path: '/category-group/edit/:id', name: 'Edit Category Group', component: NewCategoryGroup, roles: ['ADMIN'] },
];

export default routes;
